<template>
    <div>
        <div>
            <b>
                {{ defaultFrequencyLabel }}:
                <common-highlight :content="dayNames"></common-highlight>
            </b>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        props: {
            frequency: { type: String, required: true },
            frequencyLabel: { type: String, default: '' },
            startWeekDate: { type: String, default: undefined },
            days: { type: Array, required: true },
        },

        computed: {
            formattedStartWeekDate() {
                if (!this.startWeekDate) {
                    return ''
                }
                return dayjs(this.startWeekDate).format('dddd, MMMM D YYYY')
            },
            defaultFrequencyLabel() {
                if (!this.frequencyLabel) {
                    return this.frequency === 'weekly'
                        ? this.$t('forms.auth.schedule.microcopy.repeat_every')
                        : this.$t('forms.auth.schedule.microcopy.repeat_every_second')
                }
                return this.frequencyLabel
            },

            dayNames() {
                if (this.days.length === 1) {
                    return dayjs()
                        .day(this.days[0] + 1)
                        .format('dddd')
                }

                return this.days
                    .map((day) =>
                        dayjs()
                            .day(day + 1)
                            .format('ddd'),
                    )
                    .join(', ')
            },
        },
    }
</script>
